module.exports = __webpack_public_path__ + "static/media/gogreener_carbon_offset_jejakin.4b9dad15.svg";